import { Capacitor } from "@capacitor/core";

/**
 * Opens the app store listing for the specified app.
 * On native platforms, opens the native app store (App Store on iOS, Play Store on Android).
 * On web, this is a no-op.
 *
 * @param appId - The app ID (App Store ID on iOS, package name on Android)
 */
export async function openStoreListing(appId: string): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  const { NativeMarket } = await import("@capacitor-community/native-market");
  await NativeMarket.openStoreListing({ appId });
}
